import { 
  getAllRoles,
  getAllPermissions,
  getPermissionCategories
} from '../services/firebase/permissions';
import { initializePermissionData } from '../services/firebase/initializePermissions';

/**
 * Initialize the permission system on first run
 * This ensures default roles and permissions are created
 */
export const initializePermissionSystem = async (): Promise<void> => {
  try {
    console.log('Checking permission system initialization...');
    
    // Check if categories exist
    const categories = await getPermissionCategories();
    const permissions = await getAllPermissions();
    const roles = await getAllRoles();
    
    // If the system is not initialized, initialize it
    if (categories.length === 0 || permissions.length === 0 || roles.length === 0) {
      console.log('Permission system not initialized. Initializing now...');
      await initializePermissionData();
      console.log('Permission system initialized successfully');
    } else {
      console.log('Permission system already initialized');
    }
  } catch (error) {
    console.error('Failed to initialize permission system:', error);
  }
};